



























































































import Vue from 'vue';
import { KeyboardKeyCode, ListModel } from '@/types';
import FieldActionButton from '@/components/shared/FieldActionButton.vue';
import FieldTooltip from '@/components/shared/FieldTooltip.vue';
import { FormFieldValidation } from '@/mixins/formValidation';
import { ObjectHelper } from '@/mixins/objectHelper';
import { BTableHelpers } from '@/mixins/bTable';
import { FormSelectHelper } from '@/mixins/formSelectHelper';
import { ValidationModel } from '@/types/models/validation';
import { ComponentHelper } from '@/mixins/componentHelper';
import { AppSettingsHelper } from '@/mixins/appSettingsHelper';

export default Vue.extend({
  name: 'MStoreFormSelectTable',
  mixins: [FormFieldValidation, ObjectHelper, BTableHelpers, FormSelectHelper, ComponentHelper, AppSettingsHelper],
  props: {
    data: {
      required: true
    },
    top: {
      type: Number,
      required: false,
      default: undefined
    },
    list: {
      type: Object as () => ListModel,
      required: true,
      default: () => ({} as ListModel)
    },
    isLoading: {
      required: true,
      default: true
    },
    actionButtonState: {
      type: Object,
      required: false
    },
    fieldId: {
      type: String,
      required: true
    },
    fieldLabel: {
      type: String,
      required: true
    },
    isReadonly: {
      type: Boolean,
      required: true
    },
    formId: {
      type: String,
      required: false
    },
    actionButtonComponentName: {
      type: String,
      required: true
    },
    filterDisabled: {
      type: Boolean,
      default: false
    },
    displayField: {
      type: String,
      required: false
    },
    valueField: {
      type: String,
      required: false
    },
    isActionButtonDisabled: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object as () => ValidationModel,
      default: () => ({} as ValidationModel)
    },
    lineUpOnType: {
      type: Boolean,
      default: false
    },
    allowTypedValue: {
      type: Boolean,
      default: false
    },
    allowClearValue: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: ''
    }
  },
  data(this: any) {
    return {
      filter: '' as any,
      lastSelectedValue: '' as any,
      filteredItems: []
    };
  },
  computed: {
    listModel(this: any) {
      return this.list;
    },
    inputValue: {
      get(this: any) {
        return this.data;
      },
      set(this: any, value: string) {
        const flags = this.$refs.ValidationProvider.flags;
        this.$refs.ValidationProvider.setFlags({ ...flags, dirty: true });
        this.$emit('update:data', value);
      }
    },
    emptyText: {
      get(this: any) {
        return this.listModel.listDataResultTypeMessage;
      }
    },
    _valueField(this: any) {
      return this.valueField || Object.keys(this.listModel.list[0])[0];
    },
    _displayField(this: any) {
      return this.displayField || Object.keys(this.listModel.list[0])[0];
    },
    displayData(this: any) {
      return (this.list as ListModel)?.list?.find((x) => x[this._valueField] === this.data)?.[this._displayField];
    },
    isLineUpOnType(this: any) {
      return this.lineUpOnType && (!this.listHeaders || this.listHeaders?.length === 1);
    },
    showTable(this: any) {
      return !this.allowTypedValue || this.filteredItems?.length;
    },
    theadClass(this: any) {
      return this.allowTypedValue ? 'd-none' : '';
    },
    topModalRecords(this: any) {
      if (!this.allowTypedValue) {
        return 0;
      }
      if (this.top >= 0) {
        return this.top;
      }
      return this.appSettings.topModalRecords;
    },
    sizeAdjustedLabel(this: any) {
      return this.size === 'sm' ? '' : this.fieldLabel;
    },
    sizeAdjustedPlaceHolder(this: any) {
      return this.size === 'sm' ? this.fieldLabel : '';
    }
  },
  watch: {
    inputValue(this: any) {
      this.setFilter();
    },
    list() {
      this.setFilter();
    },
    showTable(this: any, newvalue: any) {
      if (newvalue && this.allowTypedValue) {
        this.initPopper();
      }
    }
  },
  methods: {
    setFilter(this: any) {
      const value = this.displayData || (this.allowTypedValue || this.lineUpOnType ? this.data : this.filter);
      this.filter = value;
      this.lastSelectedValue = value;
    },
    onEnter(this: any) {
      if (this.totalRows() === 1 && this.showTable) {
        this.onRowClicked(this.filteredItems?.[0] || this.listModel.list[0]);
      }
    },
    onfilterFocus(this: any) {
      if (!this.isReadonly && !this.isLoading && !this.tableOpen && !this.allowTypedValue) {
        this.openTable();
      }
    },
    onRowClicked(this: any, item: any) {
      this.inputValue = item[this._valueField];
      this.$emit('row-selected', item);
      this.filter = this.displayData;
      this.closeTable();
      this.setFocusOnNextTick(this.$refs.mstoreSelectTableButton);
      const focusElement = this.allowTypedValue ? this.$refs.mstoreSelectTableInput : this.$refs.mstoreSelectTableButton;
      this.setFocusOnNextTick(focusElement);
      this.validate();
    },
    onFilterButtonClicked(this: any) {
      if (this.tableOpen) {
        this.closeListAndRetainlastSelectedValue();
      } else {
        this.allowClearValue && this.inputValue ? this.clearInputValue() : this.openTable();
      }
    },
    clearInputValue(this: any) {
      this.inputValue = '';
      this.filter = '';
      this.lastSelectedValue = '';
      this.validate();
    },
    openTable(this: any) {
      this.tableOpen = true;
      this.initPopper();
    },
    customFilter(this: any, row: any, txt: any): any {
      this.clearAllSelectedRows();
      return this.customTableFilter(this.listHeaders, row, txt);
    },
    async onFiltered(this: any, filteredItems: any) {
      await this.clearAllSelectedRows();
      this.filteredItems = filteredItems;
      this.setSelectedRow();
    },
    onKeyDown(this: any, event: any) {
      if ((!this.isLineUpOnType && !this.allowTypedValue) || [KeyboardKeyCode.Tab, KeyboardKeyCode.Up, KeyboardKeyCode.Down].includes(event.keyCode)) {
        return;
      }
      if (event.keyCode === KeyboardKeyCode.Enter && !this.allowTypedValue) {
        this.closeTable();
      } else if (this.allowTypedValue && ![KeyboardKeyCode.Esc, KeyboardKeyCode.Enter].includes(event.keyCode)) {
        this.openTable();
      } else {
        event.preventDefault();
        const key = event.key as string;
        const filterList = this.listData?.filter((x: any) => {
          const value = x[this.listModel.key] as string;
          return value?.toLowerCase().startsWith(key.toLowerCase());
        });
        if (!filterList) {
          return;
        }
        const lastSelectedValueIndex = filterList?.findIndex((data: any) => data[this.listModel.key] === this.filter);

        const newIndex = lastSelectedValueIndex === -1 ? 0 : lastSelectedValueIndex >= filterList.length - 1 ? 0 : lastSelectedValueIndex + 1;

        const filter = filterList[newIndex];

        if (filter && this.tableOpen) {
          this.inputValue = filter[this._valueField];
          this.$nextTick(() => {
            this.clearAllSelectedRows();
            const element = this.setSelectedRow();
            this.setFocusOnElement(element);
          });
        }
      }
    },
    onUpDownArrowKey(this: any, event: any) {
      event.stopPropagation();

      if (this.tableOpen) {
        this.onArrowKey(event);
      }
      if (this.isLineUpOnType) {
        const index = Number(
          this.listData?.findIndex((x: any) => {
            const value = x[this.listModel.key] as string;
            return value === this.filter;
          })
        );
        const currentindex = event.keyCode === KeyboardKeyCode.Up ? index - 1 : index === -1 ? 0 : this.calculateCurrentIndexOnArrowDown(index, this.listData?.length);
        const item = this.listData[currentindex];
        if (this.isLineUpOnType && item) {
          this.$nextTick(() => (this.inputValue = item[this._valueField]));
        }
      }
    },
    setFocusForSelection(this: any) {
      if (!this.isLoading && !this.isReadonly && !this.tableOpen && this.totalRows() > 1) {
        this.focusElementById(this.elementId);
        this.openTable();
      }
    }
  },
  mounted(this: any) {
    this.setFilter();
    this.$watch(
      () => {
        return (this.$refs.ValidationProvider as any).flags.valid;
      },
      () => {
        this.popper?.update();
      }
    );
  },
  components: {
    FieldActionButton,
    FieldTooltip
  }
});
